<template>
    <div>
        <v-card flat>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                            <v-data-table
                                :headers="headers"
                                :items="calculos"
                                :rows-per-page-text="'Resultados por página'"
                            >

                            <template slot="items" slot-scope="props">
                                <td style="padding:2px;" class="text-xs-center">
                                    <v-menu 
                                        transition="scale-transition"
                                        origin="left top"
                                        bottom
                                        right
                                        slot="activator"
                                    >
                                        <v-btn class="ma-0" icon slot="activator">
                                            <v-icon>more_vert</v-icon>
                                        </v-btn>
                                        <v-list class="app-card-action">
                                            <v-list-tile 
                                                @click="mostrarDependencias(props.item._id)">
                                                <span>Dependencias</span>
                                            </v-list-tile>
                                            <!-- <v-list-tile 
                                                @click="mostrarDetalles(props.item._id)">
                                                <span>Calcular horarios</span>
                                            </v-list-tile> -->
                                            <v-list-tile 
                                                @click="modificarCalculoDialog(props.item)">
                                                <span>Modificar datos</span>
                                            </v-list-tile>
                                            <v-list-tile 
                                                @click="eliminarDialog(props.item._id)">
                                                <span>Eliminar cálculo</span>
                                            </v-list-tile>
                                        </v-list>
                                    </v-menu>

                                </td>
                                
                                <td class="text-xs-left">{{ props.item.nombre }}</td>
                                <td class="text-xs-left">{{ fechaTxt(props.item.inicio) }}</td>
                                <td class="text-xs-left">{{ fechaTxt(props.item.fin) }}</td>
                                <td class="text-xs-left">{{ dependencias(props.item.dependencias) }}</td>
                                <td class="text-xs-left">{{ props.item.observaciones }}</td>

                            </template>

                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-text v-if="puedeAgregar">
                <agregar 
                    @calculoAgregado="calculoAgregado"
                    @enviandoStart="$emit('enviandoStart')"
                    @enviandoStop="$emit('enviandoStop')"
                />
            </v-card-text>
            <div v-if="modificar.mostrar">
                <modificar-calculo 
                    :mostrar="modificar.mostrar"
                    :calculoPadre="modificar.calculo"
                    @calculoModificado="calculoModificado"
                    @cancelarModificar="modificar.mostrar=false"
                    @enviandoStart="$emit('enviandoStart')"
                    @enviandoStop="$emit('enviandoStop')"
                />
            </div>

            <div v-if="depDialog.mostrar">
                <dependencias 
                    :mostrar="depDialog.mostrar"
                    :calculo="depDialog.calculo"
                    @dependenciasAgregadas="dependenciasAgregadas"
                    @dependenciaCalculada="dependenciaCalculada"
                    @dependenciasCalculada="dependenciasCalculada"
                    @cerrarDependencias="depDialog.mostrar = false"
                />
            </div>
        </v-card>


        <!-- ELIMINAR CALCULO -->
        <v-dialog v-model="eliminar.mostrar" width="500">
            <v-card>
                <v-card-title
                class="headline grey lighten-2"
                primary-title
                >
                Adevertencia
                </v-card-title>
                <v-card-text>
                    <h3>¿Está seguro en eliminar el cálculo de horario?</h3>
                    Esta acción eliminará todas las asistencias en el rango de fechas correspondiente.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat small @click="eliminar.mostrar = false">Cancelar</v-btn>
                    <v-btn color="red darken-1" 
                        dark small 
                        @click="eliminarCalculo()">Eliminar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>

</template>

<script>

import { mapGetters } from "vuex";
import Loader from '../../../components/Loader'
import axios from 'axios'
import moment from 'moment'

import Agregar from './agregar'
import ModificarCalculo from './modificarCalculo'
import Dependencias from './dependencias'

export default {
    name: 'Calculos',
	components: {
        Agregar,
        ModificarCalculo,
        Dependencias
    },
    computed: {
        ...mapGetters([
            "sessionToken",
            "httpURL",
            "userId",
            "tableProps",
            "permisos",
            "role"
        ]),
        puedeAgregar(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 197) >= 0 ? true : false;
        },
    },
    created(){
        this.enviandoStart();
        axios.get(this.httpURL+'/calculo/listado',{headers:{token: this.sessionToken}})
            .then(res => {
                // console.log(res.data);
                this.enviandoStop();
                this.mostrar = false;
                this.calculos = res.data.calculos;
                // this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.enviandoStop();
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
    },
    data() {
        return {
            enviando:false,
            headers:[
                {text:'', value:'props', sortable:false},
                {text:'Nombre', value:'nombre', sortable:true},
                {text:'Fecha inicio', value:'inicio', sortable:true},
                {text:'Fecha fin', value:'fin', sortable:true},
                {text:'Dependencias', value:'dependencias', sortable:true},
                {text:'Observaciones', value:'observaciones', sortable:true}
            ],
            calculos:[],
            modificar: {
                mostrar: false,
                calculo: {}
            },
            depDialog: {
                mostrar: false,
                calculo: {}
            },
            eliminar:{
                mostrar: false,
                calculo: null
            }
        }
    },
    methods:{
        enviandoStart(){
            this.$emit('enviandoStart');
        },
        enviandoStop(){
            this.$emit('enviandoStop');
        },
        calculoAgregado(calculo){
            this.calculos.push(calculo);
        },
        fechaTxt(fecha){
            return moment(fecha).format('DD [de] MMMM [de] YYYY')
        },
        dependencias(dependencias){
            return dependencias.length;
        },
        modificarCalculoDialog(calculo){
            // console.log(calculo);
            this.modificar.calculo = calculo;
            this.modificar.mostrar = true;
        },
        calculoModificado(calculo){
            let index = this.calculos.findIndex(x=> x._id = calculo._id);
            this.calculos.splice(index,1,calculo);
            this.modificar.mostrar = false;
        },
        mostrarDependencias(id){
            let index = this.calculos.findIndex(x=> x._id == id);
            this.depDialog.calculo = this.calculos[index];
            this.depDialog.mostrar = true;
        },
        dependenciasAgregadas(calculo,dependencias){
            let index = this.calculos.findIndex(x=> x._id == calculo);
            this.calculos[index].dependencias = dependencias;
        },
        dependenciaCalculada(calculo,dependencia){
            let index = this.calculos.findIndex(x=> x._id == calculo);
            let indexDep = this.calculos[index].dependencias.findIndex(x=>x._id == dependencia);
            this.calculos[index].dependencias[indexDep].status = 'Calculado'
        },
        dependenciasCalculada(calculo){
            let index = this.calculos.findIndex(x=> x._id == calculo);
            this.calculos[index].dependencias.forEach(element => {
                element.status="Calculado"
            });
        },
        eliminarDialog(calculo){
            this.eliminar.calculo = calculo;
            this.eliminar.mostrar = true;
        },
        eliminarCalculo(){
            this.enviandoStart();
            axios.delete(this.httpURL+'/calculo/'+this.eliminar.calculo,
                {headers:{token: this.sessionToken}})
                .then(res => {
                    // console.log(res.data);
                    let index = this.calculos.findIndex(x=>x._id == this.eliminar.calculo);
                    this.calculos.splice(index,1);
                    this.eliminar.calculo = null;
                    this.eliminar.mostrar = false;
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
                })
                .catch(error => {
                    // console.log(error);
                    this.enviandoStop();
                    this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
                });
        }
    }
}
</script>